import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { formValueSelector, clearFields } from 'redux-form'

import { accountViewBalance } from 'src/store/account'
import CCYField from '../shared/CCYField'
import { DebitAccountCCYFieldProps } from './ConvertOnAccountInCash.types'
import { AppDispatch } from 'src/store/index.d'

const DebitAccountCCYField: FC<DebitAccountCCYFieldProps> = (props) => {
  const { form, CCY, change, CashAccounts, inCash } = props
  const dispatch = useDispatch<AppDispatch>()

  const creditCCY = useSelector((state) => formValueSelector(form)(state, 'creditCCY'))

  function handleChange(value: string) {
    if (value === creditCCY) {
      const creditChosenCCY = CCY.find((curr) => curr.ID !== value).ID

      change('creditCCY', creditChosenCCY)
      let accountInfo
      if (CashAccounts) accountInfo = CashAccounts.find((acc) => acc.CCY === creditChosenCCY)

      if (!accountInfo) {
        dispatch(
          clearFields(
            form,
            false,
            false,
            'CreditAccNo',
            'CreditTitleUNI',
            'CreditAccID',
            'CreditAccHash',
            'CreditAccBalance',
            'CreditChosenAccNo',
          ),
        )
      } else {
        const { AccountID, HashSum_AccountID_ } = accountInfo
        Promise.resolve(
          dispatch(
            accountViewBalance({
              AccountID,
              HashSum_AccountID_,
            }),
          ),
        ).then(({ payload: { Balance } }) => {
          change('CreditAccNo', accountInfo.AccNo)
          change('CreditTitleUNI', accountInfo.TitleUNI)
          change('CreditAccID', AccountID)
          change('CreditAccHash', HashSum_AccountID_)
          change('CreditAccBalance', Balance)
          change('CreditChosenAccNo', accountInfo.AccNo)
        })
      }
    }

    if (inCash) {
      const accountInfo = CashAccounts.find((acc) => acc.CCY === value)

      if (!accountInfo) {
        dispatch(
          clearFields(
            form,
            false,
            false,
            'DebitAccNo',
            'DebitTitleUNI',
            'DebitAccID',
            'DebitAccHash',
            'DebitAccBalance',
            'DebitChosenAccNo',
          ),
        )
        change('DebitAccNo', '')
      } else {
        const { AccountID, HashSum_AccountID_ } = accountInfo
        Promise.resolve(
          dispatch(
            accountViewBalance({
              AccountID,
              HashSum_AccountID_,
            }),
          ),
          // @ts-ignore
        ).then(({ payload: { Balance } }) => {
          change('DebitAccNo', accountInfo.AccNo)
          change('DebitTitleUNI', accountInfo.TitleUNI)
          change('DebitAccID', AccountID)
          change('DebitAccHash', HashSum_AccountID_)
          change('DebitAccBalance', Balance)
          change('DebitChosenAccNo', accountInfo.AccNo)
        })
      }
    } else {
      dispatch(
        clearFields(
          form,
          false,
          false,
          'DebitAccNo',
          'DebitTitleUNI',
          'DebitAccID',
          'DebitAccHash',
          'DebitAccBalance',
          'DebitChosenAccNo',
        ),
      )
      change('DebitAccNo', '')
      change('DebitTitleUNI', '')
      change('DebitAccID', '')
      change('DebitAccHash', '')
      change('DebitAccBalance', 0)
      change('DebitChosenAccNo', '')
    }
  }
  //@ts-ignore
  return <CCYField name="debitCCY" onChange={handleChange} FormName={form} ccy={CCY} debit />
}

export default DebitAccountCCYField
